import styled from "styled-components";
import {Layout, PageHeader, Menu} from "antd";

const mapPaths = ["/map", "/regions", "/heatmap", "/create-delivery-request"];
const isLogin = pathname => pathname === "/login";
const isMap = pathname => mapPaths.includes(pathname);
export const LayoutSider = styled(Layout.Sider)`
    overflow: auto;
    height: 100vh;
    position: fixed;
    transition: all 0.2s ease-in-out;
    .ant-layout-sider-trigger {
        background: #616161;
    }
    .ant-menu.ant-menu-dark .ant-menu-item-selected {
        background-color: #616161;
    }
    .ant-menu.ant-menu-dark {
        background: black;
    }
    .ant-layout-sider-children {
        overflow-y: auto;
        overflow-x: hidden;
    }
    @media screen and (max-width: 768px) {
        position: fixed;
        left: 0;
        z-index: 999;
        transform: ${props =>
            props.collapsed && isMap(props.pathname) ? "translateX(-100%)" : "translateX(0)"};
        &.ant-layout-sider-collapsed {
            width: ${props => (isMap(props.pathname) ? "0" : "80px")} !important;
            min-width: ${props => (isMap(props.pathname) ? "0" : "80px")} !important;
        }
    }
`;

export const RightLayout = styled(Layout)`
    transition: all 0.2s ease 0s;
    margin-left: ${props => (props.isloggedin ? (props.collapsed ? 80 : 200) : 0)}px;
    @media screen and (max-width: 768px) {
        margin-left: ${props => {
            if (!props.isloggedin) return 0;
            if (isMap(props.pathname) && props.collapsed) return 0;
            return props.collapsed ? 60 : 200;
        }}px;
    }
`;

export const LayoutContainer = styled(Layout)`
    min-height: 100vh;
    .ant-layout-sider {
        background: black;
    }
`;

export const LayoutHeader = styled(PageHeader)`
    background: #fff;
    z-index: 2;
    box-shadow: rgba(75, 74, 73, 0.2) 0px 1px 4px 1px;
`;

export const LayoutContent = styled(Layout.Content)`
    margin: ${props => (isMap(props.pathname) ? 0 : 16)}px;
    overflow: hidden;
    @media (max-width: 768px) {
        margin: 0px;
    }
`;

export const ChildrenContainer = styled.div`
    padding: ${props => (isMap(props.pathname) ? 0 : 24)}px;
    background: ${props => (props.pathname == "/statistics" ? "transparent" : "#fff")};
    min-height: max(
        calc(
            100vh -
                ${props =>
                    (props.pathname === "/map" || props.pathname === "/create-delivery-request") &&
                    isMap(props.pathname)
                        ? 120
                        : 144}px
        ),
        500px
    );
    position: relative;
`;

export const LayoutFooter = styled(Layout.Footer)`
    text-align: center;
    padding: 0 6px 16px 0;
    color: #a6aaaf;
    user-select: none;
`;

export const LogoImg = styled.img`
    height: 80px;
    margin: auto;
    display: flex;
`;

export const CompanyImg = styled.img`
    height: 32px;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    margin-top: -3px;
    cursor: pointer;
`;

export const MenuText = styled.span`
    margin-left: 10px;
`;

export const BottomMenu = styled(Menu)`
    position: sticky;
    bottom: -12px;
`;

export const LogoContainer = styled.div`
    cursor: pointer;
    @media screen and (min-width: 768px) {
        svg {
            display: none;
        }
    }
    @media screen and (max-width: 768px) {
        margin-left: 0px;
        padding: 10px;
        margin: "auto";
        margin-top: "15px";

        img {
            display: none;
        }
    }
`;

export const MobileMenuToggle = styled.div`
    display: none;
    position: fixed;
    top: 10px;
    left: 10px;
    z-index: 1000;
    background-color: ${props => (props.collapsed ? "rgba(0, 0, 0, 0.7)" : "transparent")};
    color: white;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

    @media screen and (max-width: 768px) {
        display: ${props => (isMap(props.pathname) ? "flex" : "none")};
    }
`;
